import React, { useCallback } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { updateChartTimeBucket } from '../../../reducer/chart.reducer'
import { SuperChartConfiguration_TimeBucket } from '../../../proto/generated/superchart-page'
import { TimeBucket_TimeSeries } from '../../../proto/generated/common'

interface ChartRestrictionOverlayProps {
    viewKey: string
    feature: string
    currentTimeBucket?: SuperChartConfiguration_TimeBucket
}

const getNextAvailableTimeBucket = (currentTimeBucket?: SuperChartConfiguration_TimeBucket): SuperChartConfiguration_TimeBucket => {
    if (!currentTimeBucket) {
        return {
            timeSeries: TimeBucket_TimeSeries.MINUTE,
            timeValue: 1,
            name: '1 Minute',
            code: 'MINUTE_1'
        }
    }

    switch (currentTimeBucket.timeSeries) {
        case TimeBucket_TimeSeries.SECOND:
            return {
                timeSeries: TimeBucket_TimeSeries.MINUTE,
                timeValue: 1,
                name: '1 Minute',
                code: 'MINUTE_1'
            }
        case TimeBucket_TimeSeries.MINUTE:
            return {
                timeSeries: TimeBucket_TimeSeries.HOUR,
                timeValue: 1,
                name: '1 Hour',
                code: 'HOUR_1'
            }
        case TimeBucket_TimeSeries.HOUR:
            return {
                timeSeries: TimeBucket_TimeSeries.DAY,
                timeValue: 1,
                name: '1 Day',
                code: 'DAY_1'
            }
        default:
            return {
                timeSeries: TimeBucket_TimeSeries.DAY,
                timeValue: 1,
                name: '1 Day',
                code: 'DAY_1'
            }
    }
}

const ChartRestrictionOverlay: React.FC<ChartRestrictionOverlayProps> = ({ 
    viewKey, 
    feature, 
    currentTimeBucket
}) => {
    const dispatch = useDispatch()
    
    const handleSwitchTimeBucket = useCallback(() => {
        const nextBucket = getNextAvailableTimeBucket(currentTimeBucket)
        dispatch(updateChartTimeBucket({ viewKey, timeBucket: nextBucket }))
    }, [viewKey, currentTimeBucket, dispatch])

    const nextBucket = getNextAvailableTimeBucket(currentTimeBucket)

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            pointerEvents: 'auto'
        }}>
            <Stack gap={2} alignItems="center">
                <Typography variant="body1" color="textSecondary" textAlign="center" maxWidth="300px">
                    This chart uses {feature} which requires a premium subscription.
                </Typography>
                <Button 
                    variant="outlined" 
                    onClick={handleSwitchTimeBucket}
                >
                    Switch to {nextBucket.name}
                </Button>
            </Stack>
        </div>
    )
}

export default ChartRestrictionOverlay
